"use client";


import { type ComponentProps, useEffect, useState } from "react";

import { cn } from "@/lib/utils";

import { productPageGalleryStore } from "./ProductPageGallery.store";

export default function ProductPageGalleryThumbnails({
  className,
  children,
  ...props
}: ComponentProps<"nav">) {
  const [isHidden, setIsHidden] = useState(false);
  const productPageGalleryPhotoSwipe = productPageGalleryStore(
    (state) => state.photoSwipe,
  );

  useEffect(() => {
    if (!productPageGalleryPhotoSwipe) {
      return;
    }

    productPageGalleryPhotoSwipe.on("beforeOpen", () => {
      setIsHidden(true);
    });

    productPageGalleryPhotoSwipe.on("closingAnimationStart", () => {
      setIsHidden(false);
    });
  }, [productPageGalleryPhotoSwipe]);

  return (
    <div className={cn("relative w-16 shrink-0 max-lg:hidden", className)}>
      <nav
        className={cn(
          "absolute inset-0 flex flex-col gap-2 overflow-y-auto scroll-smooth p-2 transition-opacity duration-300 ease-in-out scrollbar-none",
          isHidden ? "pointer-events-none opacity-0" : "",
        )}
        {...props}
      >
        {children}
      </nav>
    </div>
  );
}
